/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Invalid_StateInputs */



/**
* | output |
* | --- |
* | "Invalid OAuth state. Please try again." |
*
* @param {Login_Error_Invalid_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_error_invalid_state = /** @type {((inputs?: Login_Error_Invalid_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Invalid_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("État OAuth invalide. Veuillez réessayer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado OAuth inválido. Por favor, intente de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Estado OAuth inválido. Por favor, tente novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato OAuth non valido. Riprova.")
	return /** @type {LocalizedString} */ ("Invalid OAuth state. Please try again.")
});